export const MEDIA_UNKNOWN = 0;
export const IMAGE = 1;
export const AUDIO = 2;
export const VIDEO = 3;
export const GOOGLE_MAP_DEFAULT_ZOOM = 14;
export const GOOGLE_MAP_DEFAULT_OPTIONS = {
  streetViewControl: false,
  fullscreenControl: false,
};
export const GOOGLE_MAP_DEFAULT_OPTIONS_MEDIA = {
  streetViewControl: false,
  fullscreenControl: false,
};
export const GOOGLE_MAP_MAX_LAT = 85.0511287798066;
export const GOOGLE_MAP_MAX_LNG = 180;
export const ESCAPE_TARGET = ['%', '_'];
export const COMPANY_TYPES = ['provider', 'customer'];
export const KEY_CODE_ENTER = 13;
export const FULLSCREEN_MODE = {
  dashboard: 1,
  timeline: 2,
  timelineTile: 3,
  staff: 4,
  company: 5,
  map: 7,
  device: 8,
  master: 9,
  masterImport: 10,
  trash: 12,
  group: 13,
  actionLog: 14,
  report: 15,
  reportEdit: 16,
  accessControl: 17,
};
export const MEDIA_MAP_FULLSCREEN_MODE = {
  windowed: 1,
  fullscreen: 2,
};
export const MEDIA_FULLSCREEN_MODE = {
  windowed: 1,
  fullscreen: 2,
};
export const MEDIA_SEARCH_POSITION = {
  prev: 'PREV',
  current: 'CURRENT',
  next: 'NEXT',
};
export const CREDIBILITY_CHECK_RESULT = {
  ok: 0,
  ng: 1,
  ng_image: 2,
  ng_date: 3,
  nt: 4,
};
export const TIMELINETILE_FULLSCREEN_MODE = {
  main: 1,
  map: 2,
};
export const TIMELINE_SCREEN_MODE = {
  list: 1,
  grid: 2,
};
export const LICENSE_CAPACITY_STATUS = {
  noLicense: 0,
  ok: 1,
  upperLimit: 2,
  upperLimitExceeded: 3,
};
export const ANALYZING_STATUS = {
  noAnalysis: '0',
  underAnalysis: '1',
};

export const ACCOUNT_STATUS = {
  delete: 0,
  enable: 1,
  disable: 2,
};
export const REMOTE_SUPPORT_STATUS = {
  disable: 0,
  enable: 1,
  all: 9,
};

export const REMOTE_SUPPORT_STATUS_ALL = [
  REMOTE_SUPPORT_STATUS.enable,
  REMOTE_SUPPORT_STATUS.disable,
];

export const REMOTE_TEXT_COMMANDS = {
  display: 300,
  hide: 301,
  sendString: 302,
};

export const REMOTE_BLACKBOARD_COMMANDS = {
  show: 300,
  hide: 301,
  string: 302,
  color: 303,
  opacity: 304,
  position: 305,
};

export const ADJUST_SCREEN_COMMANDS = {
  expand: 400,
  contract: 401,
  reset: 402,
  pause: 403,
  resume: 404,
};

export const SEND_FILE_COMMANDS = {
  start: 500,
  data: 501,
  end: 502,
};

export const TLVX_RECEIVE_COMMANDS = {
  startSharing: 600,
  endSharing: 601,
  changeSharer: 602,
};

export const TLVX_COMMANDS = {
  setVideoCaptureMode: 100,
  setCameraTransMode: 200,
  sendChatData: 700,
  sendChatAndFileData: 701,
  sendChatAndFileDataEnd: 702,
};

export const TLVX_LIGHT_COMMANDS = {
  on: 800,
  off: 801,
};

export const TLVX_PHOTO_COMMANDS = {
  photo: 900,
};

export const REMOTE_MEMBER_TYPE = {
  client: 1,
  operator: 2,
};
export const REMOTE_MEMBER_STATUS = {
  wait: 1,
  joining: 2,
  joined: 3,
  left: 4,
  deny: 99,
};
export const REMOTE_DEVICE_TYPE = {
  app: 'app',
  web: 'web',
};

export const NUMBER_CHARS_ANALYZED_DATA = 50;
export const NUMBER_CHARS_ANALYZED_DATA_TILE = 20;

export const EXCLUSION_API = {
  getOperators: ['getOperators'],
  getWorkRecords: ['getWorkRecords', 'getOperatorWorkRecords'],
};

export const USER_PROMPT_MODE = {
  default: 1,
  requiredConvert: 2,
};

export const TAGS_DIALOG_SELECT_TAB = {
  update: 1,
  clear: 2,
};

export const MAX_LENGTH = {
  text: 255,
};

// 外部連携
export const PROVIDER = {
  cansuke: 'cansuke',
};

// かん助 result
export const CANSUKE_RESULT = {
  complete: 'complete',
  cancel: 'cancel',
  close: 'close',
};

export const GROUP_ROLE = {
  admin: 'super_admin',
  staff: 'staff',
};

export const ROLE = {
  INITIAL: 99,
  GUEST: 0,
  GENERAL: 1,
  ADMIN: 5,
  COMPANY_ADMIN: 10,
  SERVICE_VENDOR: 20,
  ROOT: 90,
  ALL: 100,
};

// ログイン後のメニューに表示されるページ
export const MENU = {
  dashBoard: 1, // ダッシュボード
  issue: 2, // QRコード発行
  staff: 3, // 作業者管理
  company: 4, // 企業管理
  device: 5, // デバイス管理
  master: 6, // タグ情報
  group: 7, // グループ管理
  actionLog: 8, // アクションログ管理
  report: 9, // 報告書一覧
  media: 10, // 写真一覧
  accessControl: 11, // アクセス制御
};

export const PAGE_PATH_PARAM_OPERATORID = ':operatorId';
export const PAGE_PATH = {
  ROOT: '/',
  MAP: '/map',
  TIMELINE: '/timeline',
  TIMELINE_WITH_OPERATOR_ID: `/timeline/${PAGE_PATH_PARAM_OPERATORID}`,
  TIMELINETILE: '/timelinetile',
  TIMELINETILE_WITH_OPERATOR_ID: `/timelinetile/${PAGE_PATH_PARAM_OPERATORID}`,
  TIMELINELIST: '/timelinelist',
  MEDIA: '/media/:mediaId',
  MEDIA_WITH_MEDIA_ID: '/media',
  ISSUE: '/issue',
  STAFF: '/staff',
  COMPANY: '/company',
  DEVICE: '/device',
  MASTER: '/master',
  REMOTE: '/remote',
  LOGIN: '/login',
  LOGOUT: '/logout',
  LOGIN_FAILURE: '/loginFailure',
  SELECTION: '/selection',
  ACTIVATE: '/activation',
  DS_ROOT: '/ds/',
  DS_MAP: '/ds/map',
  DS_TIMELINE: '/ds/timeline',
  DS_TIMELINE_WITH_OPERATOR_ID: `/ds/timeline/${PAGE_PATH_PARAM_OPERATORID}`,
  DS_TIMELINETILE: '/ds/timelinetile',
  DS_TIMELINETILE_WITH_OPERATOR_ID: `/ds/timelinetile/${PAGE_PATH_PARAM_OPERATORID}`,
  DS_TIMELINELIST: '/ds/timelinelist',
  DS_MEDIA: '/ds/media',
  DS_MEDIA_WITH_MEDIA_ID: '/ds/media/:mediaId',
  DS_ISSUE: '/ds/issue',
  DS_STAFF: '/ds/staff',
  DS_COMPANY: '/ds/company',
  DS_DEVICE: '/ds/device',
  DS_MASTER: '/ds/master',
  DS_REMOTE: '/ds/remote',
  DS_LOGIN: '/ds/login',
  DS_LOGOUT: '/ds/logout',
  DS_LOGIN_FAILURE: '/ds/loginFailure',
  DS_ACTIVATE: '/ds/activation',
  DS_GROUP: '/ds/group',
  DS_ACTION_LOG: '/ds/action-log',
  DS_REPORT: '/ds/report',
  DS_REPORT_EDIT: '/ds/report/edit',
  DS_REPORT_WITH_REPORT_ID: '/ds/report/edit/:reportId',
  DS_ACCESS_CONTROL: '/ds/access-control',
};

export const REMOTE_COMMAND = {
  caller: 'caller',
  answer: 'answer',
};

export const REDIRECT_REASON = {
  default: 0,
  noUser: 1,
  groupAdmin: 2,
  selectCompanyActivated: 3,
};

export const LATEST_GROUP_IDS_NUM = 3; // TODO 仮の値

export const SEARCH_GROUP_USAGE_STATUS = {
  all: 'all',
  true: 'true',
  false: 'false',
};

/** 複数人通話で通話可能な相手数 */
export const MAX_REMOTE_OPPOSITE_NUM = 9;
/** 複数人通話で同時に通話可能な最大人数 */
export const MAX_REMOTE_NUM = 10;

export const PAINT_COLORS = [
  '#E91E63',
  '#FF9800',
  '#00BCD4',
  '#BA68C8',
  '#66BB6A',
  '#FF5722',
  '#FBC02D',
  '#2196F3',
  '#9575CD',
  '#8BC34A',
];

/** タグの階層吸数 */
export const MAX_TAG_DEPTH = 5;

/** アクティビティログの最大範囲（月） */
export const ACTION_LOG_LIMIT_MONTHS = 3;

/** アクティビティログタイプ */
export const ACTION_TYPES = {
  login: 'login',
  company_select: 'company_select',
  logout: 'logout',
  photograph: 'photograph',
  movie_recording: 'movie_recording',
  voice_recording: 'voice_recording',
  download: 'download',
};

export const mediaType = {
  none: 'none',
  image: 'image',
  video: 'video',
  audio: 'audio',
};

export const EXTERNAL_LINKS = {
  TERMS_OF_SERVICE: 'https://www.optim.co.jp/eula/optim-taglet/index.html',
  PRIVACY_POLICY:
    'https://www.optim.co.jp/privacy-policy/optim-taglet/index.html',
};

export const THUMBNAIL_TITLE_DISPLAY_MODE = {
  dateDisplay: 0,
  userDisplay: 1,
  tagDisplay: 2,
};

// Cookieを利用する際のキー
export const COOKIE_KEYS = {
  DEVICE_AUTH_TOKEN: 'deviceAuthToken',
};

// Cookieの設定
export const COOKIE_CONFIG = {
  [COOKIE_KEYS.DEVICE_AUTH_TOKEN]: {
    path: '/',
    maxAge: 365 * 24 * 60 * 60,
  },
};

// デバイス認証のPINコードの桁数
export const PIN_CODE_LENGTH = 6;

// 報告書編集の写真選択ダイアログのモード
export const SELECT_MEDIA_DIALOG_MODE = {
  ADD: 'add',
  UPDATE: 'update',
};

export const REPORT_STATUS = {
  COMPLETE: 'complete',
  PUBLISHED: 'published',
  CREATE: 'create',
};

export const REPORT_UPDATE_ERROR_CODE = {
  UNEDITABLE_CONTENT: 'uneditable_content',
};

export const API_ERROR_CODE = {
  PERMISSION_REQUIRED: 'permission_required',
};
